import { queryParamKeys } from 'modules/experiments/constants';
import { TablePaginationContextState } from 'modules/experiments/types';
import { FC } from 'react';
import {
  serializationOptionsForNumberValue,
  useSearchParamState,
} from 'utils/hooks/useSearchParamState';
import {
  TablePaginationContext,
  initialTablePaginationContextState,
} from './TablePaginationContext';

export const TablePaginationContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [page, setPage] = useSearchParamState({
    searchParamKey: queryParamKeys.page,
    stateValueWhenSearchParamIsUnset: initialTablePaginationContextState.page,
    ...serializationOptionsForNumberValue,
  });

  const [pageSize, setPageSize] = useSearchParamState({
    searchParamKey: queryParamKeys.pageSize,
    stateValueWhenSearchParamIsUnset: initialTablePaginationContextState.pageSize,
    ...serializationOptionsForNumberValue,
  });

  const context: TablePaginationContextState = {
    page,
    setPage,
    /**
     * Resets to the initial table pagination count which is 1.
     * This clears off any page offset which might be already set
     * on the page. When a user tries to use a facet on the page
     */
    resetPage: () => setPage(initialTablePaginationContextState.page),
    pageSize,
    setPageSize,
  };

  return (
    <TablePaginationContext.Provider value={context}>{children}</TablePaginationContext.Provider>
  );
};
